import { UserDetails } from "@/services/UserService";

export function getUserDisplayName(firstName: string, lastName: string) {
  let value = firstName;

  if (lastName) {
    value += `. ${lastName[0]}`;
  }

  return value;
}
export function getDummyPaypipeId({ given_name, family_name }: UserDetails) {
  let value = `@${given_name}`;

  if (family_name) {
    value += `.${family_name[0]}`;
  }

  return value.toLocaleLowerCase();
}
